export enum AttemptsTypeEnum {
  VALIDATE_EMAIL = 'VALIDATE_EMAIL',
  VALIDATE_NEW_EMAIL = 'VALIDATE_NEW_EMAIL',
  VALIDATE_EMAIL_RECOVERY_PASSWORD = 'VALIDATE_EMAIL_RECOVERY_PASSWORD',
  //
  VALIDATE_PHONE = 'VALIDATE_PHONE'
}
